import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["data", "error", "loading"];
import { useMemo } from 'react';
import { useDataFetchingClient } from 'data-fetching-client';
import { useDispatch, useSelector } from 'react-redux';
import Log from 'forms-utils-lib/logger/Logger';
// @ts-expect-error untyped dependency
import { getFormGuid } from 'FormsUI/selectors/FormDefinition';
import { SINGLE_REDIRECT, ROUTE_STATE, FETCH_ROUTING_ERROR } from 'FormsUI/constants/Routing';
import { hasRoutingAccess as hasRoutingAccessFromSelector } from 'FormsUI/selectors/Scope';
// @ts-expect-error untyped dependency
import { publishFormError } from 'FormsUI/actions/FormSaving';
import { useGetDraftRoutingQuery } from '../../../../__generated__/chirp/com/hubspot/forms/routing/rpc/LegacyFormsRoutingService.hooks';
import { GET_DRAFT_ROUTING_QUERY } from '../../../../__generated__/chirp/com/hubspot/forms/routing/rpc/LegacyFormsRoutingService.dfc.new';
// replace this with the actual error type when the error type is added to the generated types on BE
const IS_NOT_FOUND_ERROR = 'com.hubspot.forms.routing.model.errors.FormRoutingNotFoundError';
export const getIsNotFoundError = error => {
  var _error$cause;
  return (error === null || error === void 0 || (_error$cause = error.cause) === null || _error$cause === void 0 || (_error$cause = _error$cause.cause) === null || _error$cause === void 0 || (_error$cause = _error$cause.cause) === null || _error$cause === void 0 ? void 0 : _error$cause.__typename) === IS_NOT_FOUND_ERROR;
};
const useFetchFormRouting = () => {
  const formGuid = useSelector(getFormGuid);
  const hasRoutingAccess = useSelector(hasRoutingAccessFromSelector);
  const dispatch = useDispatch();
  const hasAccessToRouting = hasRoutingAccess;
  const client = useDataFetchingClient();
  const showFetchRoutingError = () => {
    dispatch(publishFormError(FETCH_ROUTING_ERROR));
  };
  const _useGetDraftRoutingQu = useGetDraftRoutingQuery({
      variables: {
        formId: formGuid
      },
      skip: !formGuid || !hasAccessToRouting,
      onError(err) {
        const isNotFoundError = getIsNotFoundError(err);
        if (formGuid && isNotFoundError) {
          client.cache.writeQuery({
            query: GET_DRAFT_ROUTING_QUERY,
            variables: {
              formId: formGuid
            },
            data: {
              result: {
                formId: formGuid,
                routingPolicyGroup: SINGLE_REDIRECT.routingPolicyGroup,
                defaultRouteType: SINGLE_REDIRECT.defaultRouteType,
                defaultRouteValue: SINGLE_REDIRECT.defaultRouteValue,
                routeState: ROUTE_STATE.DISABLED
              }
            }
          });
        } else {
          Log.error('failed to fetch forms routing', {
            statusCode: 400
          });
          showFetchRoutingError();
        }
      }
    }),
    {
      data: formRouting,
      error,
      loading
    } = _useGetDraftRoutingQu,
    rest = _objectWithoutPropertiesLoose(_useGetDraftRoutingQu, _excluded);
  const isErrored = useMemo(() => {
    if (!error) return false;
    return !getIsNotFoundError(error);
  }, [error]);
  return Object.assign({
    formRouting,
    formRoutingLoading: loading,
    isErrored,
    hasAccessToRouting,
    showFetchRoutingError
  }, rest);
};
export default useFetchFormRouting;